import { useState } from "react";
/**
 * Cheap bot signals of the public registration form: the time the form was opened (a submit
 * faster than a human can fill it in is rejected). The captcha itself is the Altcha widget (DB-876).
 */
export var useRegistrationProtection = function () {
    var _a = useState(Date.now()), startTime = _a[0], setStartTime = _a[1];
    return {
        startTime: startTime,
        setStartTime: setStartTime,
    };
};
